import { WeatherConditions } from "./app.interfaces"
import { environment } from "../environments/environment"


const ICONS_DIR = "/assets/images/weather-icons"
const BG_DIR = "/assets/images/weather-backgrounds"
const VIDEO_DIR = "/assets/images/weather-videos"

// Video Einbau
// day: {
//     icon: `${ICONS_DIR}/day_sun_cloud_bright_rain_easy.svg`,
//     // backgroundImage: `${BG_DIR}/tag_regenschauer.webp`,
//     backgroundVideoUrl: `${BG_DIR}/xxx.mp4`,
//     backgroundColor: "#859EAE",
//     description: "Regenschauer"
// },


// Videos mit deren Farben
// nacht_bewoelkt (#000A1A) (OK)
// nacht_gewitter (#1B1A1D) (OK)
// nacht_regen (#0A141C) (OK)
// nacht_regenschauer (#0A141C) (OK)
// nacht_schneefall (#394148) (OK)
// nacht_schneeregen (#34434A) (OK)
// nacht_teilweise_bewoelkt (#131E2B) (OK)
// nacht_wolkenlos (#0E1924) (OK)
// tag_bewoelkt (#4F6D83) (OK)
// tag_gewitter (#646875) (OK)
// tag_regen (#586A7B) (OK)
// tag_regenschauer (#546B82) (OK)
// tag_schneefall (#B5D0DC) (OK)
// tag_schneeregen (#A3C2D1) (OK)
// tag_teilweise_bewoelkt (#3885B9) (OK)
// tag_wolkenlos (#0C70B3) (OK)


export const WEATHER_CONDITIONS: WeatherConditions = {
    "cloud_bright_rain_drizzle": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_bright_rain_drizzle.svg`,
            backgroundImage: `${BG_DIR}/tag_regenschauer.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_regenschauer.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#546B82" : "#566e81",
            description: "Leichter Nieselregen",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_bright_rain_drizzle.svg`,
            backgroundImage: `${BG_DIR}/nacht_regenschauer.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_regenschauer.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#0A141C" : "#131b24",
            description: "Leichter Nieselregen",
        },
    },
    "cloud_bright_rain_easy": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_bright_rain_easy.svg`,
            backgroundImage: `${BG_DIR}/tag_regenschauer.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_regenschauer.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#546B82" : "#566e81",
            description: "Regenschauer",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_bright_rain_easy.svg`,
            backgroundImage: `${BG_DIR}/nacht_regenschauer.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_regenschauer.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#0A141C" : "#131b24",
            description: "Regenschauer",
        },
    },
    "cloud_bright_rain_hard": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_bright_rain_hard.svg`,
            backgroundImage: `${BG_DIR}/tag_regen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_regen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#586A7B" : "#4f6272",
            description: "Regen",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_bright_rain_hard.svg`,
            backgroundImage: `${BG_DIR}/nacht_regen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_regen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#0A141C" : "#151f28",
            description: "Regen",
        },
    },
    "cloud_bright_rain_snow_easy": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_bright_rain_snow_easy.svg`,
            backgroundImage: `${BG_DIR}/tag_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#A3C2D1" : "#1e7da1",
            description: "Leichter Schneeregen",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_bright_rain_snow_easy.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#34434A" : "#41494f",
            description: "Leichter Schneeregen",
        },
    },
    "cloud_bright_rain_snow_hard": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_bright_rain_snow_hard.svg`,
            backgroundImage: `${BG_DIR}/tag_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#A3C2D1" : "#1e7da1",
            description: "Schneeregen",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_bright_rain_snow_hard.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#34434A" : "#41494f",
            description: "Schneeregen",
        },
    },
    "cloud_bright_snow_drizzle": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_bright_snow_drizzle.svg`,
            backgroundImage: `${BG_DIR}/tag_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#B5D0DC" : "#2180a4",
            description: "Leichter Schneefall",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_bright_snow_drizzle.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#394148" : "#4c545a",
            description: "Leichter Schneefall",
        },
    },
    "cloud_bright_snow_easy": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_bright_snow_easy.svg`,
            backgroundImage: `${BG_DIR}/tag_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#B5D0DC" : "#2180a4",
            description: "Schneefall",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_bright_snow_easy.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#394148" : "#4c545a",
            description: "Schneefall",
        },
    },
    "cloud_bright_snow_hard": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_bright_snow_hard.svg`,
            backgroundImage: `${BG_DIR}/tag_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#B5D0DC" : "#2180a4",
            description: "Schneefall",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_bright_snow_hard.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#394148" : "#4c545a",
            description: "Schneefall",
        },
    },
    "cloud_thunder_rain": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_thunder_rain.svg`,
            backgroundImage: `${BG_DIR}/tag_gewitter.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_gewitter.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#646875" : "#4e5460",
            description: "Gewitter",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_thunder_rain.svg`,
            backgroundImage: `${BG_DIR}/nacht_gewitter.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_gewitter.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#1B1A1D" : "#181819",
            description: "Gewitter",
        },
    },
    "cloud_thunder_rain_snow": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_thunder_rain_snow.svg`,
            backgroundImage: `${BG_DIR}/tag_gewitter.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_gewitter.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#646875" : "#4e5460",
            description: "Gewitter",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_thunder_rain_snow.svg`,
            backgroundImage: `${BG_DIR}/nacht_gewitter.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_gewitter.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#1B1A1D" : "#181819",
            description: "Gewitter",
        },
    },
    "cloud_thunder_snow": {
        day: {
            icon: `${ICONS_DIR}/day_cloud_thunder_snow.svg`,
            backgroundImage: `${BG_DIR}/tag_gewitter.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_gewitter.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#646875" : "#4e5460",
            description: "Gewitter",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloud_thunder_snow.svg`,
            backgroundImage: `${BG_DIR}/nacht_gewitter.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_gewitter.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#1B1A1D" : "#181819",
            description: "Gewitter",
        },
    },
    "cloudy_bright": {
        day: {
            icon: `${ICONS_DIR}/day_cloudy_bright.svg`,
            backgroundImage: `${BG_DIR}/tag_bewoelkt.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_bewoelkt.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#4F6D83" : "#406276",
            description: "Bewölkt",
        },
        night: {
            icon: `${ICONS_DIR}/night_cloudy_bright.svg`,
            backgroundImage: `${BG_DIR}/nacht_bewoelkt.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_bewoelkt.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#000A1A" : "#021224",
            description: "Bewölkt",
        },
    },
    "sun_bright_cloud": {
        day: {
            icon: `${ICONS_DIR}/day_sun_bright_cloud.svg`,
            backgroundImage: `${BG_DIR}/tag_teilweise_bewoelkt.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_teilweise_bewoelkt.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#3885B9" : "#227ab4",
            description: "Teilweise bewölkt",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_bright_cloud.svg`,
            backgroundImage: `${BG_DIR}/nacht_teilweise_bewoelkt.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_teilweise_bewoelkt.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#131E2B" : "#0e171d",
            description: "Teilweise bewölkt",
        },
    },
    "sun_cloud_bright_rain_drizzle": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_rain_drizzle.svg`,
            backgroundImage: `${BG_DIR}/tag_regenschauer.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_regenschauer.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#546B82" : "#566e81",
            description: "Leichter Nieselregen",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_rain_drizzle.svg`,
            backgroundImage: `${BG_DIR}/nacht_regenschauer.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_regenschauer.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#0A141C" : "#131b24",
            description: "Leichter Nieselregen",
        },
    },
    "sun_cloud_bright_rain_easy": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_rain_easy.svg`,
            backgroundImage: `${BG_DIR}/tag_regenschauer.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_regenschauer.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#546B82" : "#566e81",
            description: "Regenschauer",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_rain_easy.svg`,
            backgroundImage: `${BG_DIR}/nacht_regenschauer.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_regenschauer.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#0A141C" : "#131b24",
            description: "Regenschauer",
        },
    },
    "sun_cloud_bright_rain_hard": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_rain_hard.svg`,
            backgroundImage: `${BG_DIR}/tag_regen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_regen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#586A7B" : "#4f6272",
            description: "Regen",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_rain_hard.svg`,
            backgroundImage: `${BG_DIR}/nacht_regen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_regen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#0A141C" : "#151f28",
            description: "Regen",
        },
    },
    "sun_cloud_bright_rain_snow": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_rain_snow.svg`,
            backgroundImage: `${BG_DIR}/tag_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#A3C2D1" : "#1e7da1",
            description: "Schneeregen",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_rain_snow.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#34434A" : "#41494f",
            description: "Schneeregen",
        },
    },
    "sun_cloud_bright_rain_snow_easy": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_rain_snow_easy.svg`,
            backgroundImage: `${BG_DIR}/tag_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#A3C2D1" : "#1e7da1",
            description: "Leichter Schneeregen",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_rain_snow_easy.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#34434A" : "#41494f",
            description: "Leichter Schneeregen",
        },
    },
    "sun_cloud_bright_rain_snow_thunder": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_rain_snow_thunder.svg`,
            backgroundImage: `${BG_DIR}/tag_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#A3C2D1" : "#1e7da1",
            description: "Schneeregen",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_rain_snow_thunder.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneeregen.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneeregen.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#34434A" : "#41494f",
            description: "Schneeregen",
        },
    },
    "sun_cloud_bright_rain_thunder": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_rain_thunder.svg`,
            backgroundImage: `${BG_DIR}/tag_gewitter.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_gewitter.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#646875" : "#4e5460",
            description: "Gewitter",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_rain_thunder.svg`,
            backgroundImage: `${BG_DIR}/nacht_gewitter.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_gewitter.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#1B1A1D" : "#181819",
            description: "Gewitter",
        },
    },
    "sun_cloud_bright_snow_drizzle": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_snow_drizzle.svg`,
            backgroundImage: `${BG_DIR}/tag_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#B5D0DC" : "#2180a4",
            description: "Leichter Schneefall",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_snow_drizzle.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#394148" : "#4c545a",
            description: "Leichter Schneefall",
        },
    },
    "sun_cloud_bright_snow_easy": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_snow_easy.svg`,
            backgroundImage: `${BG_DIR}/tag_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#B5D0DC" : "#2180a4",
            description: "Schneefall",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_snow_easy.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#394148" : "#4c545a",
            description: "Schneefall",
        },
    },
    "sun_cloud_bright_snow_hard": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_snow_hard.svg`,
            backgroundImage: `${BG_DIR}/tag_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#B5D0DC" : "#2180a4",
            description: "Schneefall",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_snow_hard.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#394148" : "#4c545a",
            description: "Schneefall",
        },
    },
    "sun_cloud_bright_snow_thunder": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloud_bright_snow_thunder.svg`,
            backgroundImage: `${BG_DIR}/tag_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#B5D0DC" : "#2180a4",
            description: "Schneefall",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloud_bright_snow_thunder.svg`,
            backgroundImage: `${BG_DIR}/nacht_schneefall.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_schneefall.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#394148" : "#4c545a",
            description: "Schneefall",
        },
    },
    "sun_cloudy_bright": {
        day: {
            icon: `${ICONS_DIR}/day_sun_cloudy_bright.svg`,
            backgroundImage: `${BG_DIR}/tag_teilweise_bewoelkt.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_teilweise_bewoelkt.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#3885B9" : "#227ab4",
            description: "Meist bewölkt",
        },
        night: {
            icon: `${ICONS_DIR}/night_sun_cloudy_bright.svg`,
            backgroundImage: `${BG_DIR}/nacht_teilweise_bewoelkt.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_teilweise_bewoelkt.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#131E2B" : "#0e171d",
            description: "Meist bewölkt",
        },
    },
    "sunny": {
        day: {
            icon: `${ICONS_DIR}/day_sunny.svg`,
            backgroundImage: `${BG_DIR}/tag_wolkenlos.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/tag_wolkenlos.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#0C70B3" : "#0a71b2",
            description: "Wolkenlos",
        },
        night: {
            icon: `${ICONS_DIR}/night_sunny.svg`,
            backgroundImage: `${BG_DIR}/nacht_wolkenlos.webp`,
            backgroundVideoUrl: environment.enableWeatherVideos ? `${VIDEO_DIR}/nacht_wolkenlos.webm` : undefined,
            backgroundColor: environment.enableWeatherVideos ? "#0E1924" : "#0e1820",
            description: "Wolkenlos",
        },
    },
}

export const WIND_STRENGTH_NAMES = {
    "low": "Leichter",
    "moderate": "",
    "high": "Starker",
}

export const WIND_DIRECTION_NAMES = {
    "n": "Nordwind",
    "ne": "Nordostwind",
    "e": "Ostwind",
    "se": "Südostwind",
    "s": "Südwind",
    "sw": "Südwestwind",
    "w": "Westwind",
    "nw": "Nordwestwind",
    "xx": "Wind",
}

export const WIND_DIRECTION_TRANSLATIONS = {
    "n": "N",
    "ne": "NO",
    "e": "O",
    "se": "SO",
    "s": "S",
    "sw": "SW",
    "w": "W",
    "nw": "NW",
    "xx": "",
}

export const MW_STARTPAGE_BACKGROUND_COLOR: string = "MW_STARTPAGE_BACKGROUND_COLOR"
export const MW_STARTPAGE_BACKGROUND_IMAGE: string = "MW_STARTPAGE_BACKGROUND_IMAGE"
export const MW_STARTPAGE_BACKGROUND_POSITION: string = "MW_STARTPAGE_BACKGROUND_POSITION"
export const MW_STARTPAGE_BACKGROUND_SIZE: string = "MW_STARTPAGE_BACKGROUND_SIZE"
export const MW_STARTPAGE_TEASER_UUID: string = "MW_STARTPAGE_TEASER_UUID"
export const MW_USER_ID: string = "MW_USER_ID"

export const MW_SESSION_STORAGE_USE_REPLACEMENTS: string = "MW_SESSION_STORAGE_USE_REPLACEMENTS"
export const MW_SESSION_STORAGE_ICON_REPLACEMENT: string = "MW_SESSION_STORAGE_ICON_REPLACEMENT"
export const MW_SESSION_STORAGE_DAY_NIGHT_REPLACEMENT: string = "MW_SESSION_STORAGE_DAY_NIGHT_REPLACEMENT"
